/**
 *
 * InventoryBlocks widget container
 * Fetch data, show spinner, render error | widget as required
 *
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import inventoryBlocksModule from 'containers/App/data/endpoints/inventoryBlocks';

import messages from './messages';
import { defaultLayout } from 'containers/widgets/Widget/propTypes';

import Widget from 'containers/widgets/Widget/Widget';
import InventoryBlocks from './InventoryBlocks';
import session from 'containers/App/session';

const InventoryBlocksWrapper = ({ filters, layout = defaultLayout }) => {
    const dispatch = useDispatch();

    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const currency = useSelector(session.selectors.selectCurrency);
    const invBlocks = useSelector(inventoryBlocksModule.selectors.selectState);

    const fetchData = () => {
        const { startDate, endDate } = filters;
        dispatch(inventoryBlocksModule.actions.fetch(propertyId, startDate, endDate));
    };

    useEffect(() => {
        if (filters.startDate) {
            fetchData();
        }
    }, [propertyId, filters]);

    const state = {
        fetching: invBlocks.fetching,
        error: invBlocks.error,
        fetched: invBlocks.fetched,
    };

    return (
        <Widget layout={layout} state={state} titleMessage={messages.title} retry={fetchData}>
            <InventoryBlocks currency={currency} data={invBlocks.data} />
        </Widget>
    );
};

export default InventoryBlocksWrapper;
